import { createContext, useContext, useState } from "react";

const CurrencyCtx = createContext(null);

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(() => localStorage.getItem("fmi_currency") || "FMI");

  const update = (c) => {
    localStorage.setItem("fmi_currency", c);
    setCurrency(c);
  };

  return <CurrencyCtx.Provider value={{ currency, setCurrency: update }}>{children}</CurrencyCtx.Provider>;
};

export const useCurrency = () => useContext(CurrencyCtx);
